import React, { useEffect, useState } from "react";
import { Badge, Form, Offcanvas } from "react-bootstrap";
import ManIconHighlighted from "../../../../../img/man-highlighted.png";
import ManIconInitiate from "../../../../../img/man-initiate.png";
import ManIconRed from "../../../../../img/manred.png";
import WomanIconHighlighted from "../../../../../img/woman-avatar-highlighted.png";
import WomanIconInitiate from "../../../../../img/woman-avatar.png";
import WomanIconRed from "../../../../../img/womanred.png";
import UnknownIconHighlighted from "../../../../../img/UnknownHighlight.png";
import UnknownIconInitiate from "../../../../../img/unknown.png";
import UnknownIconRed from "../../../../../img/unknownred.png";
import { studySubjectManagementServices } from "../../../../../APIServices/studySubjectManagementServices";
import { useParams } from "react-router";

const ViewSubjectDetails = ({ Show, Hide, Title, siteId, subjectId, subjectDetails }) => {
  const [subjectRow, setSubjectRow] = useState("");
  const [screeningDate, setScreeningDate] = useState("");
  const [factors, setFactors] = useState([]);
  const [manualRandomizationNumber, setManualRandomizationNumber] = useState("");
  const [manualScreeningNumber, setManualScreeningNumber] = useState("");
  let { studyId } = useParams()
  const getStudySingleSubjectRow = async () => {
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setSubjectRow(data?.data?.row);
    setScreeningDate(data?.data?.screeningDate)
    setFactors(data?.data?.factors || [])
    setManualRandomizationNumber(data?.data?.manualRandomizationNumber)
    setManualScreeningNumber(data?.data?.manualScreeningNumber)
  }

  useEffect(() => {
    if (siteId && subjectId) {
      getStudySingleSubjectRow();
    }
  }, [siteId, subjectId]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="text-center mb-2">
            <img
              src={
                subjectDetails?.screeningStatus === "fail" ||
                  subjectDetails?.criteriaFailed
                  ? subjectDetails?.subjectGender === "male"
                    ? ManIconRed
                    : subjectDetails?.subjectGender === "female"
                      ? WomanIconRed
                      : UnknownIconRed
                  : subjectDetails?.subjectStatus === "completed"
                    ? subjectDetails?.subjectGender === "male"
                      ? ManIconHighlighted
                      : subjectDetails?.subjectGender === "female"
                        ? WomanIconHighlighted
                        : UnknownIconHighlighted
                    : subjectDetails?.subjectGender === "male"
                      ? ManIconInitiate
                      : subjectDetails?.subjectGender === "female"
                        ? WomanIconInitiate
                        : UnknownIconInitiate
              }
              alt=""
              style={{ width: 70, height: 70 }}
            />
          </div>
          <div className="text-center">
            <Badge
              bg={
                subjectDetails?.screeningStatus === "fail" ||
                  subjectDetails?.criteriaFailed
                  ? "danger-subtle"
                  : subjectDetails?.subjectStatus === "completed"
                    ? "success-subtle"
                    : "primary-subtle"
              }
              className="br3 text-dark"
              style={{ fontSize: 10 }}
            >
              {subjectDetails?.subjectName || "NA"}
            </Badge>
          </div>
          <hr />
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Screen Id : </Form.Label>
            <Form.Label>{subjectRow?.SCREENID || "NA"}</Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Random No. : </Form.Label>
            <Form.Label>{subjectRow?.RANDOMNUMBER || "NA"}</Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Subject Id : </Form.Label>
            <Form.Label>{subjectRow?.SUBJECTID || "NA"}</Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Subject Gender : </Form.Label>
            <Form.Label className="text-capitalize">
              {subjectDetails?.subjectGender || "NA"}
            </Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Subject Status : </Form.Label>
            <Form.Label className="text-capitalize">
              {subjectDetails?.subjectStatus || "NA"}
            </Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Screening Status : </Form.Label>
            <Form.Label className="text-capitalize">
              {subjectDetails?.screeningStatus || "NA"}
            </Form.Label>
          </div>
          <div className="hstack gap-2">
            <Form.Label className="fw-bold">Screening Date : </Form.Label>
            <Form.Label className="text-capitalize">
              {screeningDate || "NA"}
            </Form.Label>
          </div>
          {manualScreeningNumber &&
            <div className="hstack gap-2">
              <Form.Label className="fw-bold">Manual Screening Number : </Form.Label>
              <Form.Label className="text-capitalize">
                {manualScreeningNumber || "NA"}
              </Form.Label>
            </div>
          }
          {manualRandomizationNumber &&
            <div className="hstack gap-2">
              <Form.Label className="fw-bold">Manual Randomization Number : </Form.Label>
              <Form.Label className="text-capitalize">
                {manualRandomizationNumber || "NA"}
              </Form.Label>
            </div>
          }
          {factors?.map((item, index) => (
            <div key={index} className="hstack gap-2">
              <Form.Label className="fw-bold">{item?.name} : </Form.Label>
              <Form.Label className="text-capitalize">
                {item?.value || "NA"}
              </Form.Label>
            </div>
          ))}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectDetails;
